import { useCallback } from "react";
import { atom, useRecoilState } from "recoil";

const CS_DATA_TYPE_PLAN = 'plan';
const CS_DATA_TYPE_COPILOT = 'coPilot';
const crossSectionTypeState = atom({
  key: 'crossSectionTypeState',
  default: ''
});

const crossSectionLabelDataState = atom({
  key: 'crossSectionLabelDataState',
  default: {}
});

export const useCrossSectionData = () => {
  const [csType, setCsType] = useRecoilState(crossSectionTypeState);
  const [csLabelData, setCsLabelData] = useRecoilState(crossSectionLabelDataState);

  const isPlanType = csType === CS_DATA_TYPE_PLAN;
  const isCoPilotType = csType === CS_DATA_TYPE_COPILOT;
  let csLabel = '';
  if (isPlanType) {
    csLabel = csLabelData.aircraftCode ? csLabelData.aircraftCode : '---'
  } else if (isCoPilotType) {
    csLabel = `${csLabelData.aircraftCode} (${csLabelData.aircraftName ? csLabelData.aircraftName : csLabelData.aircraftCode})`;
  }

  const setCsTypePlan = useCallback((aircraftCode, etd) => {
    setCsType(CS_DATA_TYPE_PLAN);
    setCsLabelData({aircraftCode, etd});
  }, [setCsType, setCsLabelData]);

  const setCsTypeCoPilot = useCallback((aircraftCode, aircraftName) => {
    setCsType(CS_DATA_TYPE_COPILOT);
    setCsLabelData({aircraftCode, aircraftName});
  }, [setCsType, setCsLabelData]);

  const clearCsType = useCallback(() => {
    setCsType('');
    setCsLabelData('');
  }, [setCsType, setCsLabelData]);

  return {
    csType,
    csLabelData,
    csLabel,
    isPlanType,
    isCoPilotType,
    setCsTypePlan,
    setCsTypeCoPilot,
    clearCsType
  };
};
